import React, { useEffect, useRef, useState } from "react";
import IconAtomsClose from "../Resources/svg/Icons/IconAtomsClose";
import TitleQuoteForm from "./titleQuoteForm";
import HideInput from "./hide-input";
import limpiarIcon from "../Resources/svg/gl_delete_filled.svg";
import DetailItem from "./detailItem";
import { DualRing } from "react-loading-io";
import AlertNotifications from "./FormElements/AlertNotifications";
import { useDispatch } from "react-redux";
import { alert, stateAlert } from "../Store/simulate/actions";
import moment from "moment";
import { cardsUploadGanadas } from "../Utils/constants";
import { API } from "aws-amplify";

const modalFormRVO = ({ open, close, id_product, reloadQuotes }) => {
  const dispatch = useDispatch();
  const initialFilesValues = [
    {
      title: "Archivo",
      value: null,
      titleDate: "Fecha de Carga",
      date: null,
    },
  ];
  const [isLoading, setisLoading] = useState(false);
  const [tableRequest, setTableRequest] = useState([]);

  const [detailFiles, setDetailFile] = useState(initialFilesValues);
  const [selectedXMLFile, setSelectedXMLFile] = useState(null);
  const [processedRequests, setProcessedRequests] = useState(false);
 const [previousProccessedItems, setPreviousProccessedItems] = useState([]);

  const closeModal = () => {
    close(id_product);
  };

  const setAlert = (type, title, message) => {
    dispatch(stateAlert(true));
    dispatch(
      alert({
        type,
        title,
        message,
      })
    );

    setTimeout(() => {
      dispatch(stateAlert(false));
    }, 4000);
  };

  const saveValueOfFiles = (fileName, fileValue) => {
    const includesXML = fileName.includes("xml");

    if (!includesXML) {
      setDetailFile([...detailFiles]);
      setAlert(
        "error",
        "Archivo inválido",
        "El tipo de archivo seleccionado no es válido."
      );
      return;
    }else {
      detailFiles[0].value = fileName;
      detailFiles[0].date = currentDate;
      setSelectedXMLFile(fileValue);
    }

    const currentDate = moment().format("DD/MM/YYYY");
    detailFiles[0].value = fileName;
    detailFiles[0].date = currentDate;

    setDetailFile([...detailFiles]);
  };

  const cleanValueOfFiles = () => {
    if(detailFiles.length > 0){
      // cancelar rem prom
    if (detailFiles[1] && detailFiles[1].value) {
      detailFiles[1].value = null;
      getRequests(previousProccessedItems);
    }
    // camcelar solicitudes
    else if (detailFiles[0].value) {
      detailFiles[0].value = null;
      setProcessedRequests(false);
    }
    setDetailFile([...detailFiles]);
    }
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsText(file, "ISO-8859-1");
      reader.onload = () => {
        const text = reader.result;
        const base64 = btoa(
          Array.from(
            new TextEncoder().encode(text),
            byte => String.fromCharCode(byte)
          ).join("")
        );

        resolve(base64);
      };
      reader.onerror = reject;
    });

  const processFile = () => {
    getRequests();
    // setisLoading(true);
    // setTimeout(() => {
    //   setProcessedRequests(true);
    //   setAlert(
    //     "success",
    //     "¡Solicicitudes ganadas procesadas!",
    //     "Las solicitudes ganadas se han procesado correctamente."
    //   );
    //   setisLoading(false);
    //   closeModal();
    // }, 2000);
  };


    const getRequests = (previousRequest) => {
      if (previousRequest) {
        setTableRequest(previousRequest);
        return;
      }
      setisLoading(true);
      toBase64(selectedXMLFile).then(async (base64File) => {
        const request = {
          body: { payload: { xmlBase64: base64File } },
        };
  
        try {
          const response = await API.post(
            "api-vitalicias",
            "/solicitud/cierreGanadas",
            request
          );
          const {
            payload: { updatedElements },
          } = response;
          if (updatedElements.length > 0) {
            closeModal();
            setTableRequest(updatedElements);
            setPreviousProccessedItems(updatedElements);
            setProcessedRequests(true);
            setAlert(
              "success",
              "¡Solicicitudes ganadas procesadas!",
              "Las solicitudes ganadas se han procesado correctamente."
            );
            reloadQuotes()
          }
        } catch (err) {
          const {
            response: { data },
          } = err;
          setAlert("error", "Error", data.error.message);
          cleanValueOfFiles();
        }
        setisLoading(false);
      });
    };


  useEffect(() => {
    return () => {
      setTimeout(() => {
        setDetailFile(initialFilesValues);

        setisLoading(false);
        setProcessedRequests(false);
      }, 500);
    };
  }, [open]);

  return (
    <div className={`modalFormRVO ${open ? "is-open" : ""}`}>
      <div className="modalFormRVO__container">
        <div className="modalFormRVO__container__button" onClick={closeModal}>
          <span>Cerrar</span>
          <IconAtomsClose />
        </div>
        {!processedRequests && (
          <div className="configHome">
            <TitleQuoteForm
              title={"Cargar XML ganadas"}
              subtitle={"Carga tus cotizaciones ganadas"}
            />
            <div className="configHome__container">
              {cardsUploadGanadas.map((item, key) => (
                <HideInput
                  config={item}
                  key={key}
                  handleSendValue={(fileName, fileValue) => saveValueOfFiles(fileName, fileValue)}
                />
              ))}

              {detailFiles[0].value && (
                <div className="detailsTab">
                  <div className="detailsTab__listDetails">
                    <DetailItem
                      flag={detailFiles[0].title + ": "}
                      details={detailFiles[0].value}
                    />
                    <DetailItem
                      flag={detailFiles[0].titleDate + ": "}
                      details={detailFiles[0].date}
                    />
                  </div>
                  <a
                    onClick={() => cleanValueOfFiles()}
                    className="detailsTab__clearList"
                  >
                    <img src={limpiarIcon} /> Limpiar Datos
                  </a>
                </div>
              )}
            </div>
            <div className="modalFormRVO__action-button">
              <button
                onClick={() => processFile()}
                id="button_quote_vas"
                type="submit"
                className="btn btnew"
                disabled={!detailFiles[0].value}
              >
                Procesar
              </button>
            </div>
          </div>
        )}
      </div>

      {isLoading && (
        <div className="loading-field">
          <DualRing size={50} />
        </div>
      )}
      <AlertNotifications />
    </div>
  );
};

export default modalFormRVO;
